<template>
    <v-bottom-sheet v-model="isOpen">
        <v-list three-line subheader dense>
            <v-subheader>{{ $t('search-lbl-search-condition') }}</v-subheader>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-subtitle>
                        <v-text-field v-model="conditions.searchText" :label="$t('search-lbl-search-title')" />
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-subtitle>
                        <v-select :items="categories" :label="$t('search-lbl-category')" multiple v-model="conditions.categories"></v-select>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title>{{ $t('search-lbl-price-range') }}</v-list-item-title>
                    <v-list-item-subtitle>
                        <v-range-slider v-model="conditions.priceRange" :min="minMaxPrice.min" :max="minMaxPrice.max" hide-details class="align-center">
                            <template v-slot:prepend>
                                <v-text-field
                                    :value="conditions.priceRange[0]"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 50px"
                                    @change="$set(conditions.priceRange, 0, $event)"
                                ></v-text-field>
                            </template>
                            <template v-slot:append>
                                <v-text-field
                                    :value="conditions.priceRange[1]"
                                    class="mt-0 pt-0"
                                    hide-details
                                    single-line
                                    type="number"
                                    style="width: 50px"
                                    @change="$set(conditions.priceRange, 1, $event)"
                                ></v-text-field>
                            </template>
                        </v-range-slider>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
            <v-list-item>
                <v-list-item-content>
                    <v-row>
                        <v-col class="text-center">
                            <v-btn color="info" class="mr-4" @click="searchCondition">
                                <v-icon left>mdi-magnify</v-icon>
                                {{ $t('search-btn-search') }}
                            </v-btn>
                        </v-col>
                        <v-col class="text-center">
                            <v-btn color="error" class="mr-4" @click="resetCondition">
                                <v-icon left>mdi-magnify-close</v-icon>
                                {{ $t('search-btn-reset-condition') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-bottom-sheet>
</template>

<script>
const basePrice = 9999999999
export default {
    props: ['searcher', 'filteredGames', 'games'],
    data () {
        return {
            isOpen: false,
            conditions: {
                searchText: '',
                categories: [],
                priceRange: [0, basePrice],
            }
        }
    },
    computed: {
        categories () {
            return this.games.reduce((accumulator, currentGame) => {
                if (Array.isArray(currentGame.genres)) {
                    return [...new Set([...accumulator, ...currentGame.genres])]
                } else {
                    return [...new Set([...accumulator, currentGame.genres])]
                }
            }, []).filter(category => category != null).sort()
        },
        minMaxPrice () {
            return this.filteredGames.reduce((acc, game) => {
                if (acc.max < game.curPrice) acc.max = Math.ceil(game.curPrice)
                if (acc.min > game.curPrice) acc.min = Math.floor(game.curPrice)
                return acc
            }, {min: basePrice, max: 0})
        },
    },
    methods: {
        searchCondition () {
            this.isOpen = false
        },
        resetCondition () {
            this.conditions = {
                searchText: '',
                categories: [],
                priceRange: [0, this.minMaxPrice.max],
            }
        }
    },
    watch: {
        searcher (newValue) {
            this.isOpen = newValue
        },
        isOpen (newValue) {
            if (newValue) {
                if (this.conditions.priceRange[1] === basePrice) this.conditions.priceRange[1] = this.minMaxPrice.max
                this.prevConditions = {
                    ...this.conditions
                }
            } else {
                this.$emit('close-bottom-searcher', this.conditions)
            }
        }
    }
}
</script>

<style scoped>

</style>

